export const StorageGet = (key: string) => {
  const value = localStorage.getItem(key);
  if (!value) return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

export const StorageSet = (key: string, value: any) => {
  if (typeof value === "object") value = JSON.stringify(value);
  localStorage.setItem(key, value);
};

export const StorageRemove = (key: string) => {
  localStorage.removeItem(key);
};
